export default (state, action) => {
  return Object.assign({}, state, {
    data: Object.assign({}, state.data, {
      cart: {
        ...state.data.cart,
        ...action.payload,
        items: action.payload.items.map((item) => ({
          ...item,
          tempQuantity: item.quantity,
        })),
      },
      loading: false,
    }),
  });
};
